import React from 'react';
import { boardWidth as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const BoardWidth = (props) => {
  const name = 'board_width';
  const { parameters, errorMessage } = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label={props.label}
      name={name}
      inputId={props.inputId}
      value={parameters[name] || ''}
      required={props.required}
      placeholder={props.placeholder}
      groupName={props.groupName}
      onChange={props.onChange || onChange}
      tooltip={props.tooltip}
      className={props.className}
      inputClassName={props.inputClassName}
      errorMessage={errorMessage} />
  );
};

BoardWidth.defaultProps = {
  label: 'Board Width',
  placeholder: 'width',
  tooltip,
};

export default BoardWidth;
